import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import RAGChat from "@/components/RAGChat";
import { ChatModalProps } from "@/types";

interface ExtendedChatModalProps extends ChatModalProps {
  isAdmin?: boolean;
}

export default function ChatModal({ open, onOpenChange, isAdmin = false }: ExtendedChatModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl h-[85vh] flex flex-col p-0 gap-0">
        <DialogHeader className="p-6 pb-4 border-b border-border/50">
          <DialogTitle className="text-2xl font-bold">
            {isAdmin ? 'Admin AI Assistant' : 'AI Assistant'}
          </DialogTitle>
        </DialogHeader>
        
        <div className="flex-1 overflow-hidden p-6 pt-2">
          <RAGChat 
            isAdmin={isAdmin}
            showHeader={false}
            className="h-full border-0 shadow-none bg-transparent" 
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
